export function customScroll() {
    $(".custom-scroll").mCustomScrollbar({
        axis: "x"
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/customScroll.js